import React from 'react';
import { TrendingUp, CheckCircle } from 'lucide-react';

const Hero: React.FC = () => {
  return (
    <section className="relative min-h-screen pt-20 flex items-center overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute -right-40 -top-40 w-96 h-96 rounded-full bg-[#4CAF50]/10"></div>
        <div className="absolute -left-20 top-1/3 w-80 h-80 rounded-full bg-[#2196F3]/10"></div>
      </div>

      <div className="container mx-auto px-4 py-12 md:py-20">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-10 md:mb-0">
            <div className="animate-fadeIn">
              <div className="inline-flex items-center px-3 py-1 rounded-full bg-gradient-to-r from-[#2196F3]/10 to-[#4CAF50]/10 text-[#2196F3] font-medium text-sm mb-4">
                <TrendingUp size={16} className="mr-2" />
                AUTOMATED SYSTEM FOR SPD & OR
              </div>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6">
                Revolutionizing
                <span className="text-[#2196F3]"> Hospitals </span>
                <span className="text-[#4CAF50]"> Facilities </span>
              </h1>
              
              <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-lg">
                Intelligent hospital environment management solutions for maintaining optimal healing conditions.
              </p>

              <div className="mb-8 space-y-3">
                <div className="flex items-center text-gray-700">
                  <CheckCircle size={20} className="text-[#4CAF50] mr-2 flex-shrink-0" />
                  <span>Annual NIST-traceable sensor calibration</span>
                </div>
                <div className="flex items-center text-gray-700">
                  <CheckCircle size={20} className="text-[#4CAF50] mr-2 flex-shrink-0" />
                  <span>Comprehensive hardware maintenance included</span>
                </div>
                <div className="flex items-center text-gray-700">
                  <CheckCircle size={20} className="text-[#4CAF50] mr-2 flex-shrink-0" />
                  <span>Round-the-clock expert monitoring service</span>
                </div>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="#contact" 
                  className="bg-gradient-to-r from-[#2196F3] to-[#4CAF50] hover:opacity-90 text-white font-medium py-3 px-8 rounded-full transition-all duration-300 text-center shadow-md"
                >
                  Request Demo
                </a>
                <a 
                  href="#features" 
                  className="bg-white text-gray-800 border border-gray-200 hover:border-[#4CAF50] font-medium py-3 px-8 rounded-full transition-all duration-300 text-center"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
          
          <div className="md:w-1/2 animate-slideInRight">
            <div className="relative max-w-full">
              <div className="bg-white rounded-xl shadow-xl overflow-hidden">
                <img 
                  src="https://images.pexels.com/photos/3938022/pexels-photo-3938022.jpeg" 
                  alt="Modern hospital operating room with environmental monitoring" 
                  className="w-full h-auto"
                />
                
                <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-lg shadow-lg">
                  <div className="flex items-center space-x-3">
                    <div className="bg-[#4CAF50] h-10 w-10 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-white font-bold">99%</span>
                    </div>
                    <div>
                      <p className="text-gray-800 font-medium">Compliance Rate</p>
                      <p className="text-gray-500 text-sm">Regulatory Standards</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="absolute -top-5 -left-5 bg-white p-4 rounded-lg shadow-lg">
                <div className="flex items-center space-x-3">
                  <div className="bg-[#2196F3] h-10 w-10 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">24/7</span>
                  </div>
                  <div>
                    <p className="text-gray-800 font-medium">Expert Support</p>
                    <p className="text-gray-500 text-sm">Always Available</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;